import { OrderStatus } from "@/models/order/helpers";
import {
  LineItem,
  LineItemRecord,
  Order,
  OrderDetails
} from "@/models/order/order";
import { defaultState } from ".";
import { OrderContext, OrderMutations } from "./types";

export const addLineItem = (context: OrderContext, value: LineItem) => {
  context.commit(OrderMutations.SetLineItem, value);
};

export const editLineItem = (
  context: OrderContext,
  value: { item: LineItem; index: number }
) => {
  context.commit(OrderMutations.EditLineItem, value);
};

export const replaceLineItems = (
  context: OrderContext,
  value: LineItem[] | LineItemRecord[] | []
) => {
  context.commit(OrderMutations.SetAllLineItems, value);
};

export const addOrderStatus = (context: OrderContext, value: OrderStatus) => {
  context.commit(OrderMutations.SetStatus, value);
};

export const addShipping = (
  context: OrderContext,
  value: OrderDetails["shipping_details"]
) => {
  context.commit(OrderMutations.SetShipping, value);
};

export const addBilling = (
  context: OrderContext,
  value: OrderDetails["billing_details"]
) => {
  context.commit(OrderMutations.SetBilling, value);
};

export const addNotes = (context: OrderContext, value: string) => {
  context.commit(OrderMutations.SetNotes, value);
};

export const addPayment = (
  context: OrderContext,
  value: OrderDetails["payment_details"]
) => {
  context.commit(OrderMutations.SetPayment, value);
};

export const addContact = (
  context: OrderContext,
  value: OrderDetails["contact_details"]
) => {
  context.commit(OrderMutations.SetContact, value);
};

export const addOrder = (context: OrderContext, value: Order) => {
  context.commit(OrderMutations.SetOrder, value);
};

export const addOrderId = (
  context: OrderContext,
  value: { id: string; creator: string }
) => {
  context.commit(OrderMutations.SetOrderId, value);
};

/** See setOrder mutation */
export const clearOrder = (context: OrderContext) => {
  const blankOrder = Object.assign(
    {},
    {
      ...defaultState,
      contact_details: defaultState.contact_details,
      shipping_details: defaultState.shipping_details,
      billing_details: defaultState.billing_details,
      cost_details: defaultState.cost_details,
      notes: ""
    }
  );
  replaceLineItems(context, []);
  context.commit(OrderMutations.ClearOrder, blankOrder);
};

export const assignCustomer = (
  context: OrderContext,
  value: { customer_id: string; customer_name: string; order_id: string | null }
) => {
  context.commit(OrderMutations.SetCustomer, value);
};

export const clearCustomer = (context: OrderContext) => {
  context.commit(OrderMutations.ClearCustomer, null);
};

export const addCostDetails = (
  context: OrderContext,
  value: OrderDetails["cost_details"]
) => {
  context.commit(OrderMutations.SetCostDetails, value);
};

export const clearCreatedType = (context: OrderContext) => {
  context.commit(OrderMutations.ClearCreatedType, null);
}
